import React, { useEffect, useState } from "react";
import CreatableSelect from 'react-select/creatable';
import { useController, Controller } from "react-hook-form";
import _ from "lodash";

export const CreatableSelectField = React.forwardRef((props, ref = null) => {

    const [focusState, setFocusState] = useState(false);
    const { title, style, type, errors, defaultValue, ...others } = props;
    const { field, fieldState } = useController(props);

    let err = _.get(errors, props.name);

    const customStyles = {
        control: (base, state) => ({
            ...base,
            height: 35,
            minHeight: 35,
            // borderRadius: "7px",
            boxShadow: "none",
            minHeight: props.minHeight ? props.minHeight : "",
            // border: props.rules && err ? "1px solid #dc2626" : "1px solid #7c828f",
            // "&:hover": {
            // border: props.rules && err && "1px solid #dc2626",
            // },
            border: props.rules && err && "1px solid #dc2626",
        }),
        menu: (provided, state) => ({
            ...provided,
            zIndex: 50,
        }),
    };

    const getOptionLabel = (e) => {
        if (props.getOptionLabel) {
            return props.getOptionLabel(e);
        } else {
            return e[props.showLabel || "label"];
        }
    };


    return (
        <>
            <div className="relative w-full bg-white text-gray-500">
                <label
                htmlFor="name"
                className={`z-10 pointer-events-none absolute bg-white left-2 -mt-px inline-block px-2 font-normal 
                            ${props.rules && err ? "text-red-600" : "text-gray-600"} 
                            ${focusState || (field?.value !== null && field.value)
                    ? "-top-2 duration-300 text-xs rounded-lg"
                    : "custom-top duration-300 text-base"
                    }`}
                >
                {title}{" "}
                {props?.rules?.required?.value === true && (
                    <span className="text-red-500 mt-10">*</span>
                )}
                </label>
                <Controller
                    name={props?.name}
                    rules={props?.rules || null}
                    render={({ field }) => (
                    <CreatableSelect
                        {...field}
                        styles={customStyles ? customStyles : style}

                        options={props?.optionData}
                        getOptionLabel={getOptionLabel}
                        getNewOptionData={(inputValue, optionLabel) =>( { [props.showLabel]: inputValue })}
                        isClearable={true}
                        onFocus={() => {
                        setFocusState(true);
                        if (props.onFocus) {
                            props.onFocus(e);
                        }
                        }}
                        onBlur={(e) => {
                        field.onBlur;
                        setFocusState(false);
                        if (props.onBlur) {
                            props.onBlur(e);
                        }
                        }}
                        onChange={(val) => {
                        field.onChange(val);
                        if (props.onChange) {
                            props.onChange(val);
                        }
                        }}
                    />
                    )}
                    control={props?.control}
                />
            </div>
            {props.rules && err && props.rules && err?.message ? (
                <p className=" text-xs text-red-600 h-3" id="email-error">
                {props.rules && err && props.rules && err?.message}
                </p>
            ) : (
                ""
            )}
        </>
    );
});
